import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { Table, Drawer, Select, Collapse } from "antd";
import moment from "moment";
import CardDiv from "modules/common/card-div/CardDiv";
import CallingKpiFilter from "./CallingKpiFilter";
import { useCallingKpi } from "./store/calingKpiStore";
import { minutesToHoursMinutesString, secondsToMinutesSecondsString } from "helpers/utils";
import { getCurrentUserRole } from "modules/utilities/utility";
import { isEmpty } from "lodash";
const { Panel } = Collapse;

const CallingKpi = () => {
  const [activeKey, setActiveKey] = useState(null);
  const [engagementVisible, setEngagementVisible] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [engagementUrl, setEngagementUrl] = useState('');
  const [userUrl, setUserUrl] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [engagementCurrentPage, setEngagementCurrentPage] = useState(1);
  const [engagementPageSize, setEngagementPageSize] = useState(10);
  const [userCurrentPage, setUserCurrentPage] = useState(1);
  const [userPageSize, setUserPageSize] = useState(10);
  const [selectedValueEngagementFilter, setSelectedValueEngagementFilter] = useState(undefined);

  const getCurrentMonthDates = () => {
    const startDate = moment().format("YYYY-MM-DD");
    const endDate = moment().format("YYYY-MM-DD");
    return [startDate, endDate];
  };

  const [queryParam, setQueryParam] = useState({
    pageSize: pageSize,
    pageNumber: currentPage,
    agentUserId: "",
    agentRmUserId: "",
    process: "",
    callDate: getCurrentMonthDates(),
    team: "",
    location: null,
    house: null,
    isDownloadReq: false,
  });

  const [triggerFetch, setTriggerFetch] = useState(true);
  //TableData
  const {
    tableData,
    fetchCallingKpiFilterApply,
    filterData,
    fetchCallingKpiFilters,
    fetchEngagementData,
    tableDataLoading,
    engagementData,
    engagementDataLoading,
    fetchDetailViewData,
    userData,
    userDataLoading
  } = useCallingKpi();

  const [currentPlayingIndex, setCurrentPlayingIndex] = useState(null);

  //query
  const buildQueryString = (data) => {
    const params = new URLSearchParams();
    for (const key in data) {
      if (Array.isArray(data[key])) {
        // Join array elements with commas and wrap in square brackets
        const arrayString = `[${data[key].join(",")}]`;
        params.append(key, arrayString);
      } else if (data[key] !== undefined && data[key] !== "") {
        params.append(key, data[key]);
      } else {
        params.append(key, "");
      }
    }
    return `?${params.toString()}`;
  };

  //pagination
  const handleTableChange = (pagination) => {
    const updatedPagination = {
      ...queryParam,
      pageSize: pagination.pageSize,
      pageNumber: pagination.current,
    };
    setPageSize(pagination.pageSize);
    setCurrentPage(pagination.current);
    setQueryParam(updatedPagination);
    const updatedFilters = filterAndTransformParams(updatedPagination);
    setQueryParam(updatedFilters);
    setTriggerFetch(true);
  };

  //pagination
  const handleEngagementTableChange = (pagination) => {
    setEngagementCurrentPage(pagination.current);
    setEngagementPageSize(pagination.pageSize);
    const [path, queryString] = engagementUrl.split('?');
    let params = new URLSearchParams(queryString);
    params.set('pageNumber', pagination.current);
    params.set('pageSize', pagination.pageSize);
    !isEmpty(selectedValueEngagementFilter) && params.set('status', selectedValueEngagementFilter);
    const modifiedUrl = `${path}?${params.toString()}`;
    fetchEngagementData(modifiedUrl);
  };

  const handleDetailTableChange = (pagination) => {
    setUserCurrentPage(pagination.current);
    setUserPageSize(pagination.pageSize);
    const [path, queryString] = userUrl.split('?');
    let params = new URLSearchParams(queryString);
    params.set('pageNumber', pagination.current);
    params.set('pageSize', pagination.pageSize);
    const modifiedUrl = `${path}?${params.toString()}`;
    fetchDetailViewData(modifiedUrl);
  };

  //params as strings
  const filterAndTransformParams = (params) => {
    return Object.fromEntries(
      Object.entries(params)
        .filter(([key, value]) =>
          Array.isArray(value) ? value.length > 0 : value
        )
        .map(([key, value]) => [
          key,
          Array.isArray(value) ? JSON.stringify(value) : value,
        ])
    );
  };

  useEffect(() => {
    if (triggerFetch) {
      const updatedFilters = filterAndTransformParams(queryParam);
      const queryString = buildQueryString(updatedFilters);

      fetchCallingKpiFilterApply(queryString);
    }
    setTriggerFetch(false);
  }, [triggerFetch, queryParam]);

  useEffect(() => {
    fetchCallingKpiFilters();
  }, []);

  //handleApplyfilter

  const handleApplyFilters = (filters) => {
    let updatedFilters = { ...filters };

    if (
      updatedFilters.reporting_manager &&
      updatedFilters.reporting_manager.length > 0
    ) {
      updatedFilters = transformReportingManagerFilter(
        updatedFilters,
        tableData
      );
    }

    const mergedFilters = {
      ...queryParam,
      ...updatedFilters,
      pageSize: 10,
      pageNumber: 1,
    };

    const finalFilters = filterAndTransformParams(mergedFilters);
    setQueryParam(finalFilters);
    setTriggerFetch(true);
    setCurrentPage(1);
    setPageSize(10);
  };

  const onClickEmpIdData = (detailViewUrl, summaryViewUrl) => {
    setEngagementUrl(detailViewUrl);
    setUserUrl(summaryViewUrl);
    setEngagementVisible(true);
  };

  const handleManualDownloadClick = async () => {
    setIsDownloading(true);
    try {
      queryParam.isDownloadReq = true;
      const updatedFilters = filterAndTransformParams(queryParam);
      const queryString = buildQueryString(updatedFilters);

      const response = await fetchCallingKpiFilterApply(queryString, true);

      // Assume response.data contains the CSV data
      const csvData = response.data;

      // Default filename if none is provided in the response headers
      let filename = 'calling_kpi.csv';

      // Check if the response headers contain a 'Content-Disposition' header with the filename
      const contentDisposition = response.headers['content-disposition'];
      if (contentDisposition) {
        // Extract the filename from the 'Content-Disposition' header using a regular expression
        const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
        if (filenameMatch && filenameMatch.length > 1) {
          filename = filenameMatch[1]; // Use the extracted filename if available
        }
      }
      // Create a Blob from the CSV data with the appropriate MIME type
      const blob = new Blob([csvData], { type: 'text/csv' });
      // Create a temporary URL for the Blob
      const url = URL.createObjectURL(blob);
      // Create a temporary anchor element to initiate the download
      const a = document.createElement('a');
      a.href = url;
      a.download = filename; // Set the filename for the downloaded file
      // Append the anchor to the document body and trigger a click to start the download
      document.body.appendChild(a);
      a.click();
      // Remove the anchor from the document after the download is initiated
      document.body.removeChild(a);
      // Revoke the temporary URL to free up memory
      URL.revokeObjectURL(url);

    } catch (error) {
      console.error('Error downloading CSV file:', error);
    } finally {
      setIsDownloading(false);
    }
  };

  const handleChangeEngagementSelectFilter = (value) => {
    setSelectedValueEngagementFilter(value);

    const [path, queryString] = engagementUrl.split('?');
    let params = new URLSearchParams(queryString);
    !isEmpty(value) && params.set('status', value);
    const modifiedUrl = `${path}?${params.toString()}`;
    fetchEngagementData(modifiedUrl);
  };

  // Modify columns
  const updatedEngagementHeaders = engagementData.headers.map(col => {
    if (col.dataIndex === 'customerName') {
      return {
        ...col,
        render: customerObject => {
          const URL = `/${customerObject.type}/${customerObject.code}`;
          return (<Link target="_blank" to={URL}>{customerObject.value}</Link>)
        }
      };
    }
    if (col.dataIndex === 'callDuration') {
      return {
        ...col,
        render: callDuration => secondsToMinutesSecondsString(callDuration)
      };
    }
    if (col.dataIndex === 'callTalkTime') {
      return {
        ...col,
        render: callTalkTime => secondsToMinutesSecondsString(callTalkTime)
      };
    }
    if (col.dataIndex === 'recordings') {
      return {
        ...col,
        render: (text, record, index) => {
          return record.recordings ? (
            <audio
              controls
              src={record.recordings}
              data-index={index}
              onPlay={(event) => handlePlay(event, currentPlayingIndex, setCurrentPlayingIndex, index)}
            >
              Your browser does not support the audio element.
            </audio>
          ) : (
            <span>No recording available</span>
          );
        }
      };
    }
    return col;
  });

  // Modify columns
  const updatedUsersHeaders = userData.headers.map(col => {
    if (col.dataIndex === 'totalTalkTime') {
      return {
        ...col,
        render: totalTalkTime => minutesToHoursMinutesString(totalTalkTime)
      };
    }
    if (col.dataIndex === 'totalTimeSpent') {
      return {
        ...col,
        render: totalTimeSpent => minutesToHoursMinutesString(totalTimeSpent)
      };
    }
    return col;
  });

  const handlePlay = (event, currentPlayingIndex, setCurrentPlayingIndex, index) => {
    const audioElement = event.target;

    // Pause the currently playing audio if it's different from the current one
    if (currentPlayingIndex !== null && currentPlayingIndex !== index) {
      const previousAudio = document.querySelector(
        `audio[data-index="${currentPlayingIndex}"]`
      );
      if (previousAudio) {
        previousAudio.pause();
        previousAudio.currentTime = 0;
      }
    }

    // Set the current playing audio index
    setCurrentPlayingIndex(index);
  };


  const updatedRows = tableData.rows_data.map((row) => {
    const { employeeId } = row;
    const { callDate } = queryParam;
    let parsedCallDate;

    if (typeof callDate === 'string') {
      try {
        parsedCallDate = JSON.parse(callDate);
      } catch {
        // Default to today's date if parsing fails
        parsedCallDate = getCurrentMonthDates();
      }
    } else {
      parsedCallDate = callDate;
    }

    // Validation to check if URL, type, or value is missing
    if (_.isEmpty(employeeId.detail_view.url)) {
      // alert("Invalid employee data: URL, type, or value is missing");
      return {
        ...row,
        totalTalkTime: minutesToHoursMinutesString(row.totalTalkTime ?? 0),
        totalTimeSpent: minutesToHoursMinutesString(row.totalTimeSpent ?? 0),
      }
    }

    // Construct URL
    let detailViewUrl = !_.isEmpty(employeeId.detail_view.url) ? employeeId.detail_view.url : `/${employeeId.detail_view.type}/${employeeId.detail_view.value}`;
    let summaryViewUrl = !_.isEmpty(employeeId.summary_view.url) ? employeeId.summary_view.url : `/${employeeId.summary_view.type}/${employeeId.summary_view.value}`;

    detailViewUrl += `?startDate=${parsedCallDate[0]}&endDate=${parsedCallDate[1]}&pageNumber=${engagementCurrentPage}&pageSize=${engagementPageSize}`;
    summaryViewUrl += `?startDate=${parsedCallDate[0]}&endDate=${parsedCallDate[1]}&pageNumber=${userCurrentPage}&pageSize=${userPageSize}`;

    return {
      ...row,
      totalTalkTime: minutesToHoursMinutesString(row.totalTalkTime ?? 0),
      totalTimeSpent: minutesToHoursMinutesString(row.totalTimeSpent ?? 0),
      employeeId: (
        <span
          onClick={() => onClickEmpIdData(detailViewUrl, summaryViewUrl)}
          style={{ color: 'blue', cursor: 'pointer', textDecoration: 'none' }}
        >
          {employeeId.detail_view.value}
        </span>
      ),
    };
  });

  const handleChangeAccordian = async (key) => {
    const activeKey = key[0];
    setActiveKey(activeKey);
    if (!activeKey) return;
    // Define URL and fetch functions for each view
    const viewConfig = {
      detail_view: {
        url: engagementUrl,
        fetchData: fetchEngagementData,
        setPage: setUserCurrentPage,
        setPageSize: setUserPageSize,
      },
      summary_view: {
        url: userUrl,
        fetchData: fetchDetailViewData,
        setPage: setEngagementCurrentPage,
        setPageSize: setEngagementPageSize,
      },
    };

    const { url, fetchData, setPage, setPageSize } = viewConfig[activeKey];

    if (url && fetchData) {
      const [path, queryString] = url.split('?');
      const params = new URLSearchParams(queryString);
      const modifiedUrl = `${path}?${params.toString()}`;

      await fetchData(modifiedUrl);
      setPage(1);
      setPageSize(10);
    }
  };

  return (
    <CardDiv
      title={<div className="d-flex justify-content-between">
        <span>KPI Calling Dashboard</span>
        <span>
          {["super_admin", "admin", "team_lead"].includes(getCurrentUserRole()) && <Button
            type="secondary"
            shape="round"
            style={{ marginRight: 10 }}
            onClick={handleManualDownloadClick}
          >
            {isDownloading ? 'Downloading' : 'Download'}
          </Button>}

          <span className="shadow p-2 text-nowrap text-center">
            Results: {tableData.total_row_count}
          </span>
        </span>
      </div>}
      className="pt-0"
      component={
        <>
          <Drawer
            title="Engagement Report"
            placement="right"
            onClose={() => { setEngagementVisible(false); setSelectedValueEngagementFilter(undefined); setActiveKey('')}}
            open={engagementVisible}
            width="80%"
            zIndex={999999999}
          >
            <Collapse accordion activeKey={activeKey} onChange={handleChangeAccordian}>
              <Panel header="Detail View" key="detail_view">
                <>
                  <div className="d-flex justify-content-end mb-3">
                    <Select
                      style={{ width: 200 }}
                      placeholder="Select an option"
                      value={selectedValueEngagementFilter}
                      onChange={handleChangeEngagementSelectFilter}
                    >
                      <Option value="answered">Answered</Option>
                      <Option value="unanswered">Unanswered</Option>
                      <Option value="">NA</Option>
                    </Select>
                  </div>
                  <Table
                    size="small"
                    loading={engagementDataLoading}
                    columns={updatedEngagementHeaders}
                    dataSource={engagementData.rows_data}
                    pagination={{
                      current: engagementCurrentPage,
                      pageSize: engagementPageSize,
                      total: engagementData.total_row_count,
                      showSizeChanger: false,
                    }}
                    onChange={handleEngagementTableChange}
                  />
                </>
              </Panel>
              <Panel header="Summary View" key="summary_view">
                <>
                  <Table
                    size="small"
                    loading={userDataLoading}
                    columns={updatedUsersHeaders}
                    dataSource={userData.rows_data}
                    pagination={{
                      current: userCurrentPage,
                      pageSize: userPageSize,
                      total: userData.total_row_count,
                      showSizeChanger: false,
                    }}
                    onChange={handleDetailTableChange}
                  />
                </>
              </Panel>
            </Collapse>

          </Drawer>

          <CallingKpiFilter
            queryParam={queryParam}
            filterData={filterData}
            onApplyFilters={handleApplyFilters}
            setQueryParam={setQueryParam}
            setCurrentPage={setCurrentPage}
            setPageSize={setPageSize}
            initialCallDate={getCurrentMonthDates()}
            setTriggerFetch={setTriggerFetch}
          />
          <div className="table-responsive">
            <Table
              size="small"
              loading={tableDataLoading}
              columns={tableData.headers}
              dataSource={updatedRows}
              onChange={handleTableChange}
              pagination={{
                current: currentPage,
                pageSize: pageSize,
                total: tableData.total_row_count,
                showSizeChanger: true,
              }}
              scroll={{ x: "max-content" }}
            />
          </div>
        </>
      }
    />
  );
};

export default CallingKpi;